import styled from 'styled-components';

const FromToTableFooter = styled.div`
  border-top: solid 2px ${props => props.theme.border.raeCardFooter};
  border-bottom: solid 2px ${props => props.theme.border.raeCardFooter};
  padding: 0.75rem 0;
  color: ${props => props.theme.fontColors.raeCardFooter};
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  letter-spacing: ${props => props.theme.letterSpacing.pont5};
  & > div {
    margin-bottom: 0.25rem;
  }
`;

export const FromCardFooter = styled(FromToTableFooter)`
`;

export const DataValue = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: 14px;
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: 1.43;
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: #022737;
`;

export const DataValueColorNavy = styled(DataValue)`
  color: #022737;
`;

export const InvestmentOption = styled.div`
font-family: HelveticaNeue;
font-size: 14px;
line-height: 1.38;
color: #006778;
text-decoration:underline;
cursor:pointer;
`;

export const DataHeading = styled.div`
  font-family: HelveticaNeue;
  font-size: 14px;
  font-style: normal;
  width: 100%;
  margin-bottom:5px;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: 1.43;
  color: #505050;
`;

export const DisplayMobFooter = styled.div`
  margin: 20px;
  div {
    justify-content: space-between;
    div:last-child {
      display: flex;
      flex-direction: column;
    }
  }
`;

export const Total = styled.div`
  font-family: HelveticaNeue-Bold; 
  color: ${props => props.theme.fontColors.headingColor};
`;